<template>
  <v-expansion-panel>
    <secao-personalizada-expansion-panel-header
      :ticket-id="ticketId"
      :formulario-id="formularioId"
      :titulo="titulo"
      :qtd-colunas="qtdColunas"
      :solicitante-data="solicitanteData"
      :impressao-disponivel="impressaoDisponivel"
      :elementos-versao-impressao="elementosVersaoImpressao"
      :componente-text-label-options="componenteTextLabelOptions"
    />

    <v-expansion-panel-content>
      <tabela-de-celulas
        :ticket-id="ticketId"
        :formulario-id="formularioId"
        :qtd-colunas="qtdColunas"
        :elementos="elementos"
        :align-center="true"
        :componente-text-label-options="componenteTextLabelOptions"
        :handle-input-change="adicionarFormularioResposta"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Vue from 'vue'
import { computed } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import TabelaDeCelulas from './TabelaDeCelulas.vue'
import SecaoPersonalizadaExpansionPanelHeader from './SecaoPersonalizadaExpansionPanelHeader.vue'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'
import ComponenteTextLabelOptions from '@/models/props/ComponenteTextLabelOptions'

export default {
  components: {
    SecaoPersonalizadaExpansionPanelHeader,
    TabelaDeCelulas,
  },

  props: {
    ticketId: {
      type: Number,
      required: true,
    },
    formularioId: {
      type: Number,
      required: true,
    },
    qtdColunas: {
      type: Number,
      default: 0,
    },
    titulo: {
      type: String,
      required: true,
    },
    empresaNome: {
      type: String,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    elementos: {
      type: Array,
      default: () => [],
    },
    impressaoDisponivel: {
      type: Boolean,
      required: true,
    },
    solicitanteData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formularioRespostas: [],
    }
  },

  computed: {
    elementosPorLinha() {
      const elementosPorLinha = []
      this.elementos
        .map(linha => linha.filter(comp => comp.visivel))
        .forEach(elementoPai => {
          elementoPai.forEach(item => {
            if (!elementosPorLinha[item.linha]) {
              elementosPorLinha[item.linha] = []
            }
            elementosPorLinha[item.linha].push(item)
          })
        })

      return elementosPorLinha
    },
  },

  methods: {
    async handleAnexoUpload(files) {
      const anexos = []
      files.forEach(file => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          const dataUrl = reader.result
          const tamanhoImagemEmMB = new Blob([dataUrl]).size / 1_048_576

          if (tamanhoImagemEmMB > 1) {
            Vue.$toast.warning('O arquivo não pode ter mais de 1MB.', { timeout: false })
          } else {
            anexos.push({
              nome: file.name,
              dataUrl,
            })
          }
        }
      })
      return anexos
    },

    async adicionarFormularioResposta(valorSelecionado, id, idElementoTipo, label) {
      const formularioResposta = {
        idFormularioElemento: id,
        idFormularioElementoOpcaoResposta: null,
        respostaTexto: null,
        respostaBool: null,
        formularioId: this.formularioId,
        anexos: null,
      }

      // eslint-disable-next-line default-case
      switch (idElementoTipo) {
        case TiposDeComponentesEnum.TextBox:
          formularioResposta.respostaTexto = valorSelecionado
          break

        case TiposDeComponentesEnum.RadioGroup:
          formularioResposta.idFormularioElementoOpcaoResposta = valorSelecionado
          break

        case TiposDeComponentesEnum.CheckBox:
          formularioResposta.respostaBool = valorSelecionado
          break

        case TiposDeComponentesEnum.DropDownList:
          formularioResposta.idFormularioElementoOpcaoResposta = valorSelecionado
          break

        case TiposDeComponentesEnum.DropDownListEncadeado:
          formularioResposta.idFormularioElementoOpcaoResposta = valorSelecionado
          break

        case TiposDeComponentesEnum.Arquivo:
          formularioResposta.anexos = await this.handleAnexoUpload(valorSelecionado)
          formularioResposta.respostaTexto = label
          break

        case TiposDeComponentesEnum.Assinatura:
          formularioResposta.anexos = [{ nome: label, dataUrl: valorSelecionado }]
          formularioResposta.respostaTexto = label
          break

        case TiposDeComponentesEnum.Numerico:
          formularioResposta.respostaTexto = valorSelecionado
          break
      }

      const indexResposta = this.formularioRespostas.findIndex(resposta => resposta.idFormularioElemento === id)
      if (indexResposta !== -1) {
        this.formularioRespostas[indexResposta] = formularioResposta
      } else {
        this.formularioRespostas.push(formularioResposta)
      }

      this.$emit('atualizar-respostas', this.formularioRespostas)

      if (idElementoTipo === TiposDeComponentesEnum.Assinatura) {
        this.$emit('update-ticket')
      }
    },
  },

  setup(props) {
    const elementosVersaoImpressao = computed(() => props.elementos.map(linha => linha.filter(comp => comp.idElementoTipo !== TiposDeComponentesEnum.Arquivo)))

    const enderecoFormatado = computed(() => {
      if (!props.solicitanteData.enderecos || !props.solicitanteData.enderecos.length) return ''

      const { rua, numero, bairro, cidade, estado, cep } = props.solicitanteData.enderecos[0]

      return `${rua}, nº ${numero}, ${bairro}, ${cidade}, ${estado}, ${cep}`
    })

    const componenteTextLabelOptions = computed(() => new ComponenteTextLabelOptions({
      solicitanteNome: props.solicitanteData.nome,
      enderecoFormatado: enderecoFormatado.value,
      empresaNome: props.empresaNome,
    }))

    return {
      elementosVersaoImpressao,
      componenteTextLabelOptions,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
